/**
 * «Atualizar» de uma encomenda à espera no Odoo (dupla validação, moeda
 * diferente) — 0.36.0. Puro (testado em `tests/armazem-encomenda.test.ts`):
 * só se liga (ou confirma) a MESMA encomenda que ficou à espera. Se o plano
 * já não a encontra — foi rejeitada (cancelada) ou apagada no Odoo — diz-se
 * isso e nunca se cria outra sem passar pelo diálogo.
 */
export interface RefreshPlan {
  action: "create" | "link" | "confirm" | "stop"
  existing: { id: number; name: string | null } | null
  blockers: string[]
}

export type RefreshDecision = { kind: "post" } | { kind: "error"; message: string }

export function refreshDecision(plan: RefreshPlan, waiting: { order_id: number | null; order_name: string | null }): RefreshDecision {
  const name = waiting.order_name ?? (waiting.order_id ? String(waiting.order_id) : "")
  if ((plan.action === "link" || plan.action === "confirm") && plan.existing && plan.existing.id === waiting.order_id) return { kind: "post" }
  if (plan.action === "stop" && plan.existing?.id === waiting.order_id) {
    return { kind: "error", message: plan.blockers.join(" ") || `A encomenda ${name} ainda não está confirmada no Odoo.` }
  }
  if (plan.action === "create" || (plan.existing && plan.existing.id !== waiting.order_id) || !plan.existing) {
    return {
      kind: "error",
      message: `A encomenda ${name} foi rejeitada ou apagada no Odoo — reveja antes de criar outra (em «Criar encomenda a partir do documento»).`,
    }
  }
  return { kind: "error", message: plan.blockers.join(" ") || "Ainda não se pode ligar a encomenda." }
}
